import { ref } from 'vue'
import { useQuoteHistoryData } from './useQuoteHistoryData.js'
import { useQuoteHistoryCalls } from './useQuoteHistoryCalls.js'

/**
 * Composable pour gérer l'historique d'un devis
 * Limite: 40 lignes max
 */
export function useQuoteHistory(quoteId) {
  const showAutomaticEmailsInfo = ref(false)
  const showCallsInfo = ref(false)
  const showStatusChangesInfo = ref(false)

  const {
    history,
    loadingHistory,
    loadHistory
  } = useQuoteHistoryData(quoteId)

  const {
    showCallForm,
    editingCall,
    savingCall,
    callForm,
    editCall,
    closeCallForm,
    saveCall,
    deleteCall
  } = useQuoteHistoryCalls(quoteId, loadHistory)

  return {
    history,
    loadingHistory,
    showCallForm,
    showAutomaticEmailsInfo,
    showCallsInfo,
    showStatusChangesInfo,
    editingCall,
    savingCall,
    callForm,
    loadHistory,
    editCall,
    closeCallForm,
    saveCall,
    deleteCall
  }
}

